/* eslint-disable max-len */
/**
 * @Description:
 * @author WZP
 * @date 2021/8/25
 */

import React from 'react';
import classNames from 'classnames/bind';

import styles from './styles.scss';
import PageContainer from 'containers/en/page-container';
import Section from 'components/section';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';
import { history } from '@store/history';
import { TEACHER_COUNTRY_CONIFG } from './const';
import { COUNTRYCODE_LANG_MAP, COUNTRY_CONFIG } from 'constants/country';

const cx = classNames.bind(styles);

const teachList = [
	{
		avatr: 'https://web-data.zmlearn.com/image/v5Z2pT6ZNEaKY3zWzeqS9H/tutors_4%402x.png',
		name: 'Adolph',
		school: 'University of Cambridge',
		desc: `<p>Subject: English, Maths</p><p>Grade: Y7-Y11</p><p>Completed lessons: 2561</p>`,
	},
	{
		avatr: 'https://web-data.zmlearn.com/image/hsW7YRPGPpgpMXpouXYVcS/avator2.png',
		name: 'Hannah',
		school: 'Imperial College London',
		desc: `<p>Subject: English, Maths</p><p>Grade: Y1-Y6</p><p>Completed lessons: 1092 </p>`,
	},
	{
		avatr: 'https://web-data.zmlearn.com/image/aggjtMMyP9tNTosWgXSemd/avator3.png',
		name: 'Brian',
		school: 'University of Oxford',
		desc: `<p>Subject: Biology, Physics</p><p>Grade: Y12-Y13</p><p>Completed lessons: 1270</p>`,
	},
];
const teacherIntro = [
	{
		tchImg: 'https://web-data.zmlearn.com/image/gkU36deZ1p3WiW4bwFSLB5/_png_01.png',
		title: '10,000+',
		desc: 'AirClass provides 10,000+ online tutors for students in all subjects and at all levels of study; Anyone in the world can experience AirClass’ first-class tutoring, anywhere and anytime.',
	},
	{
		tchImg: 'https://web-data.zmlearn.com/image/fJfkLDe6ptN4d8ZgAuyCgn/_png_03.png',
		title: 'Top Universities',
		desc: 'Tutors have all been to top universities and many of them have professional teaching qualifications or currently work in a top school. All the tutors have more than 2 years of teaching experiences.',
	},
	{
		tchImg: 'https://web-data.zmlearn.com/image/v7cXdKK85oadcEKBuRamQp/_png_04.png',
		title: '7.8%',
		desc: 'AirClass tutors have passed strict selection standards. Only 1 out of 13 candidates can be a tutor at AirClass. Access to an expert tutor who is matched to your student’s personality and learning style.',
	},
];
function OurTutors(props: Record<string, any>) {
	const local = useSelector((state: ConnectState) => state.app.local);
	const countryCode = useSelector((state: ConnectState) => state.app.countryCode);
	const teachers = TEACHER_COUNTRY_CONIFG[local] || TEACHER_COUNTRY_CONIFG['en-US'];
	const path = '/' + (countryCode || 'en');
	
	return (
		<PageContainer>
			<div className={cx('tutors')}>
				<div className={cx('banner-block')}>
					<div className={cx('blue-circle', 'banner-top')}></div>
					<div className={cx('tl-circle', 'banner-left')}></div>
					<div className={cx('')}></div>
					<img loading="lazy" src="https://web-data.zmlearn.com/image/93LiPYPmiQ7misd9KahAKU/title_01.png" alt="" className={cx('text')} />
					<img
						loading="lazy"
						src="https://web-data.zmlearn.com/image/6xCTX3eDUDVRfwtcag5H8Y/banner_tutors.png"
						alt=""
						className={cx('banner')}
					/>
				</div>
				<div className={cx('tutors-container')}>
					<div className={cx('yel-circle', 'one')}></div>
					<div className={cx('yel-circle', 'two')}></div>
					<Section>
						{teacherIntro.map((item, index) => (
							<div
								className={cx('list', {
									reserve: !!(index % 2),
								})}
								key={index}>
								<div className={cx('icon')}>
									<img loading="lazy" src={item.tchImg} alt="" />
								</div>
								<div className={cx('text')}>
									<h2 className={cx('title')}>{item.title} </h2>
									<div className={cx('desc')} dangerouslySetInnerHTML={{ __html: item.desc }} />
								</div>
							</div>
						))}
					</Section>
				</div>
				<Section>
					<div className={cx('')}></div>
					<div className={cx('layout')}>
						<div className={cx('teacher-infos-block')}>
							<h1>Tutors you can rely on 100%</h1>
							<div className={cx('teacher-infos', 'scroll-view')}>
								{teachers.map((v) => {
									return (
										<div className={cx('item')} key={v.name}>
											<i className={cx('avatar')} style={{ backgroundImage: `url(${v.avatr})` }} />
											<div className={cx('name')}>{v.name}</div>
											<div className={cx('school')}>{v.school}</div>
											<div className={cx('score')}>
												<img loading="lazy" src="https://web-data.zmlearn.com/image/imnZ81spWbvU1No2G8C3RQ/4%402x.png" />
											</div>
											<div className={cx('desc')} dangerouslySetInnerHTML={{ __html: v.desc }} />
											<button onClick={() => history.push(path)}>Arrange A Trial Lesson ➞</button>
										</div>
									);
								})}
							</div>
							<button className={cx('view-more')} onClick={() => history.push(path)}>
								View more tutors
							</button>
						</div>
					</div>
				</Section>
			</div>
		</PageContainer>
	);
}

export default OurTutors;
